import React from 'react';
import { findAccess, formatNumberWithCommas, history } from '../../utils';
import { IDashboardResumeProps } from '../../ts/interface/pages/dashboard.interface';
import { IDashboardStat } from '../../ts/interface/dashboardStats.interface';
import LineChartUp04Icon from '../../icons/untitled-ui/duocolor/line-chart-up-04';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import BikeScooterIcon from '@mui/icons-material/BikeScooter';
import DirectionsBikeIcon from '@mui/icons-material/DirectionsBike';
import QuickStats from '../../components/Redesing/quick-stats';

const DashboardResume = ({
  systemAccess,
  mode,
  new_hardware,
  stats,
  isLoading,
}: IDashboardResumeProps) => {
  const dashboardStats = stats || ({} as IDashboardStat);
  const access = findAccess(systemAccess) || [];

  return (
    <div>
      <QuickStats
        // Only until the first response. The counters refetch whenever the page
        // changes its graph date range, and re-showing a spinner over values that
        // are about to come back identical just makes the tiles flicker.
        isLoading={!stats && isLoading}
        sections={[
          {
            title: 'Active Rentals',
            id: 'active-rentals',
            value: formatNumberWithCommas(dashboardStats?.active_rentals || 0),
            icon: <DirectionsBikeIcon />,
            onClick: () => {
              if (access.includes('rental')) {
                history.push('/rentals?status=active');
              }
            },
          },
          {
            title: 'Total Rentals',
            id: 'total-rentals',
            value: formatNumberWithCommas(dashboardStats?.total_rentals || 0),
            icon: <LineChartUp04Icon />,
            onClick: () => {
              if (access.includes('rental')) {
                history.push('/rentals');
              }
            },
          },
          {
            title: 'Total Users',
            id: 'total-users',
            value: formatNumberWithCommas(dashboardStats?.total_users || 0),
            icon: <PeopleOutlineIcon />,
            onClick: () => {
              if (access.includes('users')) {
                history.push('/users');
              }
            },
          },
          {
            title: `Available ${mode?.details?.pluralUnits || ''}`,
            id: 'available-hardware',
            value: formatNumberWithCommas(dashboardStats?.available_hardware || 0),
            icon: <BikeScooterIcon />,
            onClick: () => {
              if (access.includes('physical')) {
                history.push(
                  new_hardware
                    ? `/hardware?type=${mode.details.hardware_type}&status=active`
                    : '/units/generalUnits'
                );
              }
            },
          },
        ]}
      />
    </div>
  );
};

export default DashboardResume;
